import { render, staticRenderFns } from "./AddStaff.vue?vue&type=template&id=7a1bb2af&scoped=true"
import script from "./AddStaff.vue?vue&type=script&lang=js"
export * from "./AddStaff.vue?vue&type=script&lang=js"
import style0 from "./AddStaff.vue?vue&type=style&index=0&id=7a1bb2af&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1bb2af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a1bb2af')) {
      api.createRecord('7a1bb2af', component.options)
    } else {
      api.reload('7a1bb2af', component.options)
    }
    module.hot.accept("./AddStaff.vue?vue&type=template&id=7a1bb2af&scoped=true", function () {
      api.rerender('7a1bb2af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/users/AddStaff.vue"
export default component.exports